import Washi from 'washi';
import Callout from './components/callout';
import Compare from './components/compare';
import TrackSources from '../components/track-sources';

Washi(Callout);
Washi(Compare);
TrackSources();
